import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import globals from '../../../globals/communityGlobals';
import useTimeline from '../timeline/useTimeline';
import { postUnbundleTreatmentInstance } from '../../../actions/areas/planner';

const dailyPlanningLocale = globals.getArea('dailyPlanning');
const treatmentLocale = globals.getArea('treatments');

export default function UnbundleTreatment({ onSuccess, onBack, treatmentInstanceId }) {
  const { getAccessToken } = useTimeline();
  const [error, setError] = useState(null);
  const [disableButtons, setDisableButtons] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);

  const headerRender = () => {
    return (
      <div className="sidePanel-header form-header">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">{dailyPlanningLocale.getMsg('unbundle')}</Typography>
            </Box>
          </Box>
        </div>
      </div>
    );
  };

  const confirmationMessage = () => {
    return (
      <div>
        <div className="sidePanel-content content-top-padding">
          <Typography variant="h6" gutterBottom>
            {dailyPlanningLocale.getMsg('unbundleTreatmentInstanceConfirmation')}
          </Typography>
        </div>
      </div>
    );
  };

  const onSave = () => {
    const onErrorResponse = errorResponse => {
      setError(errorResponse.message);
      setDisableButtons(false);
      setIsDataLoading(false);
    };

    setDisableButtons(true);
    setIsDataLoading(true);

    postUnbundleTreatmentInstance(getAccessToken, { bundleTreatmentInstanceId: treatmentInstanceId }, onErrorResponse);
    onSuccess();
  };

  const errorRender = () => {
    return error ? (
      <div>
        <Grid className="form-validation-error">
          <p>{error}</p>
        </Grid>
      </div>
    ) : (
      <React.Fragment />
    );
  };

  const footerRender = () => {
    return (
      <div className="sidePanel-footer">
        <div className="sidePanel-buttons">
          <div className="sidePanel-BackButton">
            <Button variant="contained" color="secondary" onClick={onBack} disabled={disableButtons}>
              {treatmentLocale.getMsg('back')}
            </Button>
          </div>
          <div className="sidePanel-saveButton">
            <Button variant="contained" color="primary" onClick={onSave} disabled={disableButtons}>
              {treatmentLocale.getMsg('save')}
              {isDataLoading && <CircularProgress style={{ marginLeft: '5px' }} size={18} color="inherit" />}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open>
        <div className="sidePanel-wrapper" style={{ width: '350px' }} id="total-duration">
          {headerRender()}
          {confirmationMessage()}
          {errorRender()}
          {footerRender()}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
